import i18n from 'modules/core/lib/i18n'

import { Tour } from 'modules/product_updates/components/ProductUpdatesTourList'

import { useGetProductTours } from './useGetProductTours'

const useToursData = (handleStartTourTest: (tourId: number) => void) => {
  const { productTours } = useGetProductTours({})

  if (!productTours || productTours.length === 0) {
    // eslint-disable-next-line no-type-assertion/no-type-assertion
    return { groupedTours: {} as Record<string, Tour[]> }
  }

  const TOURS: Tour[] = productTours.map((tour) => ({
    id: tour.id,
    title: tour.title,
    description: tour.description,
    buttonText: i18n.t('product_updates.tours.button_text'),
    helpCenterUrl: tour.helpCenterUrl ?? '',
    onClick: () => handleStartTourTest(Number(tour.intercomId) || 0),
    tourGroup: tour.tourGroup ?? '',
  }))

  const groupTours = (tours: Tour[]): Record<string, Tour[]> => {
    return tours.reduce(
      (acc, tour) => {
        const group = tour.tourGroup ?? ''
        if (!acc[group]) {
          acc[group] = []
        }
        acc[group].push(tour)
        return acc
      },
      {} as Record<string, Tour[]>
    )
  }

  const groupedTours = groupTours(TOURS)
  return { groupedTours }
}

export default useToursData
